
import React from "react";
import type { ContentBlockSlice } from "~/lib/prismic/types.generated";
import type { SliceComponentProps } from "@commercekit/prismic";
import DuoContent from "./variations/DuoContent";


const ContentBlocks = ({ slice }: SliceComponentProps<ContentBlockSlice>) => {
  switch (slice.variation) {
    case "duoContent": {
      return <DuoContent slice={slice} />;
    }
    default:
      return <div className="hidden">ContentBlocks</div>;
  }
};

export default ContentBlocks;
